@if (isMulti()) {
  <elcia-multi-dropdown
    [control]="control()"
    [items]="activityTypes()"
    [label]="'entity.activity-types' | translate"
    [textField]="'name'"
    [valueField]="'id'"
  />

} @else {

  <elcia-dropdown
    [control]="control()"
    [items]="activityTypes()"
    [label]="'entity.activity-type' | translate"
    [textField]="'name'"
    [valueField]="'id'"
  />

}
